//C0001: Strictly Necessary Cookies
//C0002: Performance Cookies
//C0003: Functional Cookies
//C0004: Targeting Cookies
//C0005: Social Media Cookies

import $ from 'jquery';
import { readCookie } from './utils.js'

$('.main').hasClass('webinar-internal') && $('#player').addClass('hidden');

const otActive = () => {
    if (
        (typeof OnetrustActiveGroups != 'undefined' && OnetrustActiveGroups.includes("C0001"))
    ) return true;
    return false;
}

const showHideAdvice = () => {
    let isOtActive = otActive();
    if ($("#cover-subscribe").length === 0) {
        if (isOtActive) {
            $('.advice').hide();
            $('.main').hasClass('courses-internal') && $('.video-iframe').removeClass('overlay advice-wrapper');
            $('.main').hasClass('capsule-internal') && $('.video-iframe').removeClass('overlay');
        } else {
            $('.main').hasClass('courses-internal') && $('.video-iframe').addClass('overlay advice-wrapper');
            $('.main').hasClass('capsule-internal') && $('.video-iframe').addClass('overlay');
            $('.advice').show();
        }
    } else {
        return;
    }

    if ($(".video-iframe.finish-parcial").length === 1 || $(".start-parcial").length === 1 || $(".video-iframe.parcial").length === 1 || $(".video-iframe.finish-evaluation").length === 1) {
        $('.main').hasClass('courses-internal') && $('.video-iframe').addClass('overlay');
    }
}

const widthListener = () => {
    let btn = $('.advice .dp-button');

    ($(window).width() < 768) ? (btn.addClass('button-small').removeClass('button-medium')) : (btn.addClass('button-medium').removeClass('button-small'));

    $(window).on('resize', () => {
        ($(window).width() < 768) ? (btn.addClass('button-small').removeClass('button-medium')) : (btn.addClass('button-medium').removeClass('button-small'));
    });
}

// Webinars
const otWebinars = () => {
    let isOtActive = otActive();

    if (!!readCookie("webinar_subscription_v2")) {
        if (isOtActive) {
            $('.main').hasClass('webinar-internal') && $('#player').removeClass('hidden');
            $('.main').hasClass('webinar-internal') && $('.webinar-advice').removeClass('active');
            $('.main').hasClass('webinar-internal') && $('.webinar-advice').addClass('hidden');
            $('.main').hasClass('webinar-internal') && $('.suggestion-overlay').removeClass('suggestion-active');

        } else {
            $('.main').hasClass('webinar-internal') && $('#player').addClass('hidden');
            $('.main').hasClass('webinar-internal') && $('.webinar-advice').removeClass('hidden');
            $('.main').hasClass('webinar-internal') && $('.webinar-advice').addClass('active');
            $('.main').hasClass('webinar-internal') && $('.video-iframe').addClass('suggestion-active');
        }

    }
}
const otWebinarsOnLoad = () => {
    let isOtActive = otActive();

    $('.main-content--webinar').hasClass('webinar--proximo') && $('.webinar-advice').remove();

    if (!!readCookie("webinar_subscription_v2")) {
        $('.main').hasClass('webinar-internal') && $('.video-iframe').addClass('has_cookie');

        setTimeout(() => {
            if (isOtActive) {
                $('.main').hasClass('webinar-internal') && $('#player').fadeIn('slow').removeClass('hidden');
            } else {
                $('.main').hasClass('webinar-internal') && $('.webinar-advice').removeClass('hidden').addClass('active').hide().fadeIn('fast');
                $('.main').hasClass('webinar-internal') && $('.suggestion-overlay').addClass('suggestion-active');
            }
        }, 1250);
    }
}
// Webinars

const otListener = () => {
    showHideAdvice();
    widthListener();
    otWebinarsOnLoad(); // Webinar onLoad

    $('body').on('click', function (e) {
        let target = $(e.target);

        let btnClickedAccept = (target.is('#onetrust-accept-btn-handler') || target.is('#accept-recommended-btn-handler')), // "Aceptar todas las cookies" or "Permitirlas todas" Button
            btnClickedClose = (target.is('.onetrust-close-btn-handler') || target.is('#close-pc-btn-handler')), // "Close icon" Button
            btnClickedPreference = (target.is('.save-preference-btn-handler')); // "Confirmar mis preferencias" Button

        if (btnClickedAccept || btnClickedClose || btnClickedPreference) {
            $('html').css('overflow', 'auto');
            showHideAdvice();
            otWebinars(); // Webinar onClick
        }
    });
}

export default otListener;
